import React from 'react'
import { styled } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import Avatar from '@mui/material/Avatar'
import { deepOrange } from '@mui/material/colors'
import * as utils from '../../../util/bellplus-utils'
import defaultProfileIcon from '../../../images/UserProfile.svg'

const PREFIX = 'HeaderProfile';

const classes = {
  headerProfile: `${PREFIX}-headerProfile`,
  profileButton: `${PREFIX}-profileButton`,
  profileAvatar: `${PREFIX}-profileAvatar`,
  profileName: `${PREFIX}-profileName`,
  profileMenu: `${PREFIX}-profileMenu`,
  username: `${PREFIX}-username`,
  orange: `${PREFIX}-orange`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.headerProfile}`]: {
    display: 'inline-flex',
    marginLeft: theme.spacing(2),
  },

  [`& .${classes.profileButton}`]: {
    borderRadius: 30,
    fontSize: '1.2rem',
    padding: 8,
  },

  [`& .${classes.profileAvatar}`]: {
    width: 35,
    height: 35,
    marginRight: 10,
  },

  [`& .${classes.profileName}`]: {
    fontWeight: 500,
    marginRight: 5,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },

  [`& .${classes.profileMenu}`]: {
    marginLeft: '16px',
  },

  [`& .${classes.username}`]: {
    marginTop: 10,
  },

  [`& .${classes.orange}`]: {
    color: theme.palette.getContrastText(deepOrange[500]),
    backgroundColor: deepOrange[500],
  }
}));

const HeaderProfile = () => {

  let userDetails = utils.getData('userDetails')

  let profilePic =
    userDetails && userDetails.data && userDetails.data.profilePicUrl
      ? userDetails && userDetails.data && userDetails.data.profilePicUrl
      : defaultProfileIcon

  return (
    <Root className={classes.headerProfile}>
      <div>
        <Avatar className={classes.profileAvatar} alt={''} src={profilePic} />
      </div>
    </Root>
  );
}

export default HeaderProfile
